(function(){
  if (window.__bfcmVip) return; window.__bfcmVip = true;
  var pad = function(n){ return String(n).padStart(2,'0'); };
  function getZonedParts(timestamp, timeZone){
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(timestamp));
    var result = {};
    parts.forEach(function(part){ if (part.type !== 'literal') result[part.type] = Number(part.value); });
    return result;
  }
  function getTimeZoneOffset(timestamp, timeZone){
    var parts = getZonedParts(timestamp, timeZone);
    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - timestamp;
  }
  function parseStoreLocalTarget(value, timeZone){
    var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value || '');
    if (!match) return NaN;
    var year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
    var hour = Number(match[4]), minute = Number(match[5]), second = Number(match[6] || 0);
    var utc = Date.UTC(year, month - 1, day, hour, minute, second);
    var target = utc - getTimeZoneOffset(utc, timeZone);
    var adjustedOffset = getTimeZoneOffset(target, timeZone);
    if (adjustedOffset !== getTimeZoneOffset(utc, timeZone)) target = utc - adjustedOffset;
    var parts = getZonedParts(target, timeZone);
    if (parts.year !== year || parts.month !== month || parts.day !== day || parts.hour !== hour || parts.minute !== minute || parts.second !== second) return NaN;
    return target;
  }
  function tick(){
    document.querySelectorAll('[data-bfcm-countdown]').forEach(function(el){
      var t = parseStoreLocalTarget(el.getAttribute('data-local-target'), el.getAttribute('data-time-zone'));
      if (isNaN(t)) return;
      var diff = Math.max(0, t - Date.now()) / 1000;
      var d = Math.floor(diff/86400), h = Math.floor(diff%86400/3600), m = Math.floor(diff%3600/60), s = Math.floor(diff%60);
      var set = function(k,v){ el.querySelectorAll('[data-u="'+k+'"]').forEach(function(n){ n.textContent = v; }); };
      set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
      set('short', d + 'd ' + pad(h) + 'h ' + pad(m) + 'm');
    });
  }
  function phases(){
    var now = new Date(); now.setHours(0,0,0,0);
    document.querySelectorAll('[data-bfcm-timeline]').forEach(function(tl){
      var items = [].slice.call(tl.querySelectorAll('[data-start]'));
      var cur = -1;
      items.forEach(function(it,i){
        var s = new Date(it.getAttribute('data-start')+'T00:00:00'), e = new Date((it.getAttribute('data-end')||it.getAttribute('data-start'))+'T23:59:59');
        if (now >= s && now <= e) cur = i;
      });
      if (cur < 0) cur = 0;
      items.forEach(function(it,i){ it.classList.toggle('is-now', i===cur); it.classList.toggle('is-past', i<cur); });
    });
  }
  function bar(){
    var b = document.querySelector('[data-bfcm-bar]'); var f = document.querySelector('[data-bfcm-formwrap]');
    if (!b || !f) return;
    document.body.classList.add('bfcm-has-bar');
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ b.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); });
    io.observe(f);
  }
  function topbar(){
    var ph = document.querySelector('[data-bfcm-top-ph]'), t = ph && ph.querySelector('[data-bfcm-top]');
    if (!t) return;
    var setH = function(){ ph.style.height = t.offsetHeight + 'px'; };
    setH(); window.addEventListener('resize', setH);
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ t.classList.toggle('is-fixed', !e.isIntersecting && e.boundingClientRect.top < 0); }); }, { threshold: 0 });
    io.observe(ph);
  }
  document.addEventListener('click', function(e){
    var go = e.target.closest('[data-bfcm-goto-form]');
    if (go){ var f = document.querySelector('[data-bfcm-formwrap]'); if (f){ e.preventDefault(); window.scrollTo({top: f.getBoundingClientRect().top + window.scrollY - 90, behavior:'smooth'}); var i = f.querySelector('input[type=email]'); if (i) setTimeout(function(){ i.focus({preventScroll:true}); }, 500); } }
    var sh = e.target.closest('[data-bfcm-share]');
    if (sh){ e.preventDefault(); var url = location.href.split('?')[0]; if (navigator.share) navigator.share({title: document.title, url: url}).catch(function(){}); else if (navigator.clipboard) { navigator.clipboard.writeText(url); sh.textContent = sh.getAttribute('data-copied') || 'Link copied'; } }
  });
  function init(){ tick(); phases(); bar(); topbar(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(){ tick(); phases(); topbar(); });
})();
